import {
  EMPRESA_LOAD_ALL,
  EMPRESA_CREATE_PRICE_GROUP,
  EMPRESA_CREATE_REMOTE_REPOSITORY,
  EMPRESA_NORMALIZE_IDERP,
  EMPRESA_COPY_PRICE,
  EMPRESA_SYNCHRONIZE_PRODUCTS,
  EMPRESA_SYNCHRONIZE_ORDERS,
  EMPRESA_SYNCHRONIZE_CLIENTS,
  EMPRESA_CREATE,
  EMPRESA_TFA,
  EMPRESA_DELETE,
  EMPRESA_LOAD_TAGS
} from "../actions/empresa";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [EMPRESA_LOAD_ALL]: ({ dispatch }) => {
    return new Promise((resolve, reject) => {
      Api.v2.empresa
        .listAll()
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_CREATE_PRICE_GROUP]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .createGroupPrice(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_CREATE_REMOTE_REPOSITORY]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .createRemoteRepository(payload.idfornecedor, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_NORMALIZE_IDERP]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .normalizarIdErpProdutos(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_COPY_PRICE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .copiarPrecoPaje(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_SYNCHRONIZE_PRODUCTS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .sincroniaProdutosIndexador(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_SYNCHRONIZE_ORDERS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .sincroniaPedidoIndexador(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_SYNCHRONIZE_CLIENTS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.supplier
        .sincroniaClienteIndexador(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_CREATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.empresa
        .inserirOuAtualizar(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_TFA]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.empresa
        .enviarTFA(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_DELETE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.empresa
        .excluir(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [EMPRESA_LOAD_TAGS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.empresa
        .getTags(payload.idempresa)
        .then(resp => {
          resolve(resp.data || []);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
